import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineStore } from 'pinia';
import { familyApi } from '~/core/api/familyApi';
import TokenManager from '~/core/utils/tokenManagers/tokenManager';
export default defineStore('family-access', function () {
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  var _managers = {};
  var getTokenManager = function getTokenManager(sharingUuid, profileUuid) {
    if (!_managers[sharingUuid]) {
      _managers[sharingUuid] = {};
    }
    if (!_managers[sharingUuid][profileUuid]) {
      _managers[sharingUuid][profileUuid] = new TokenManager(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$familyApi$getI, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return familyApi.getInfoFamilyAccessToken(sharingUuid, profileUuid);
            case 3:
              _yield$familyApi$getI = _context.sent;
              data = _yield$familyApi$getI.data;
              return _context.abrupt("return", data.accessToken);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              $captureException(_context.t0, {
                component: 'useFamilyAccessStore',
                method: 'getTokenManager',
                sharingUuid: sharingUuid,
                profileUuid: profileUuid
              });
              throw _context.t0;
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      })));
    }
    return _managers[sharingUuid][profileUuid];
  };
  var getProfileTokenManager = function getProfileTokenManager(profile) {
    if (!(profile !== null && profile !== void 0 && profile.isShared)) {
      return;
    }
    if (!profile.sharingUuid) {
      $captureException(new Error('Отсутствует sharing_uuid для профиля'), {
        component: 'useFamilyAccessStore',
        method: 'getProfileTokenManager',
        profileUuid: profile.uuid
      });
      return;
    }
    return getTokenManager(profile.sharingUuid, profile.uuid);
  };
  var clear = function clear() {
    _managers = {};
  };
  return {
    getProfileTokenManager: getProfileTokenManager,
    clear: clear
  };
});